class DiscountProgress extends HTMLElement {
  connectedCallback() {
    this.rules = JSON.parse(this.dataset.rules || '{}').rules ?? [];
    if (!this.rules.length) return;
    this.render([]);
    this.loadCart();
    this.watchCart();
    this.barColor = this.dataset.barColor || '#E02124';
    this.textColor = this.dataset.textColor || '#111827';
  }

  loadCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => this.update(cart.items));
  }

  watchCart() {
    const watched = ['/cart/add', '/cart/change', '/cart/update'];
    const orig = window.fetch.bind(window);
    window.fetch = (...args) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
      const promise = orig(...args);
      if (watched.some(p => url.includes(p))) {
        promise.then(() => this.loadCart());
      }
      return promise;
    };
    document.addEventListener('cart:updated', () => this.loadCart());
  }

  update(items) {
    this.render(items);
  }

  qualifyingQty(rule, items) {
    return items
      .filter(item => {
        if (rule.targetType === 'all') return true;
        if (rule.targetType === 'products') {
          return rule.targetIds.includes(`gid://shopify/Product/${item.product_id}`);
        }
        return false;
      })
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  progressData(rule, items) {
    const qty = this.qualifyingQty(rule, items);
    const { buyQuantity, payQuantity, fixedPrice, ruleType } = rule;
    const groups = Math.floor(qty / buyQuantity);
    const remainder = qty % buyQuantity;
    const needed = remainder === 0 ? buyQuantity : buyQuantity - remainder;
    const pct = groups > 0 ? 100 : Math.round((remainder / buyQuantity) * 100);

    let deal, unlocked;
    if (ruleType === 'buy_x_pay_y') {
      const free = buyQuantity - payQuantity;
      deal = this.dataset.discountBuyXPayY.replace('{{buyQuantity}}', buyQuantity).replace('{{free}}', free);
      const freeItems = this.dataset.youHaveXFreeItems.replace('#X#', groups * free);
      unlocked = groups > 0
        ? freeItems
        : null;
    } else {
      deal = this.dataset.discountAnyXForY.replace('{{buyQuantity}}', buyQuantity).replace('{{fixedPrice}}', Number(fixedPrice).toFixed(2));
      unlocked = groups > 0
        ? `You have ${groups} group${groups !== 1 ? 's' : ''} at $${Number(fixedPrice).toFixed(2)}!`
        : null;
    }

    return { deal, unlocked, needed, pct, qty, active: groups > 0 };
  }

  render(items) {
    this.innerHTML = this.rules.map(rule => {
      const { deal, unlocked, needed, pct, active, qty } = this.progressData(rule, items);
      // if (qty === 0) return '';
      const now = Date.now();
      if (rule.startsAt && new Date(rule.startsAt).getTime() > now) return '';
      if (rule.endsAt && new Date(rule.endsAt).getTime() < now) return '';

      const title = this.dataset.titleMessage.replace('#X#', needed).replace('#DEAL#', deal);
      const message = active
        ? unlocked
        : title;

      const emptyMessage = this.dataset.emptyMessage.replace('#X#', needed).replace('#DEAL#', deal);

      return `
        <div class="w-full" style="margin-bottom: 12px; color: ${this.textColor};">
          <p class="text-center" style="margin: 0 0 6px; font-size: 0.875em; font-weight: 500;">
            ${qty === 0 ? emptyMessage : message}
          </p>
          <div style="background:${this.barColor}; border-radius:9999px; height:6px; overflow:hidden;">
            <div style="background:currentColor; width:${pct}%; height:100%;
                        border-radius:9999px; transition:width 0.3s ease;"></div>
          </div>
        </div>
      `;
    }).join('');
  }
}

customElements.define('discount-progress', DiscountProgress);
